import { makeStyles } from '@material-ui/core/styles';
import {
  MAIN_HEADER_MIN_HEIGHT,
  BUTTON_HEADER_MIN_HEIGHT,
} from '../../../../constants/Layout';

export const useHeaderStyles = makeStyles((theme) => ({
  mainRoot: {
    '&.MuiAppBar-colorPrimary': {
      backgroundColor: 'rgb(26, 26, 26)',
    },
    zIndex: theme.zIndex.drawer + 1,
  },
  toolbar: {
    marginTop: '28px',
  },
}));

export const useMainHeaderStyles = makeStyles(() => ({
  typography: {
    '&.MuiTypography-root': {
      marginLeft: 30,
    },
  },
  toolbar: {
    '&.MuiToolbar-regular': {
      minHeight: MAIN_HEADER_MIN_HEIGHT,
    },
  },
  divider: {
    height: 70,
    '&.MuiDivider-root': {
      background: '#464646',
    },
  },
}));

export const useButtonHeaderStyles = makeStyles(() => ({
  root: {
    '&.MuiToolbar-dense': {
      minHeight: BUTTON_HEADER_MIN_HEIGHT,
      backgroundColor: 'rgb(49, 49, 49)',
    },
    '&.MuiToolbar-gutters': {
      paddingLeft: 0,
    },
  },
  button: {
    color: 'rgb(151, 153, 155)',
    fontSize: 12,
    maxHeight: 28,
  },
}));
